import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

/**
 * FAQ component — visible accordion. Pair with <Seo faq={…}/> for FAQPage schema.
 * items: [{q, a}, …]
 */
export const Faq = ({ title = "Veelgestelde vragen", eyebrow = "FAQ", items = [] }) => {
  const [open, setOpen] = useState(null);
  if (items.length === 0) return null;
  return (
    <section
      data-testid="faq-section"
      className="bg-background py-20 lg:py-28"
    >
      <div className="mx-auto max-w-3xl px-6 lg:px-10">
        <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--sand-dark))]">
          {eyebrow}
        </p>
        <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] text-[hsl(var(--ink))] sm:text-5xl">
          {title}
        </h2>
        <div className="mt-10 divide-y divide-[hsl(var(--border))] border-t border-b border-[hsl(var(--border))]">
          {items.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-start justify-between gap-6 py-6 text-left"
                >
                  <span className="font-display text-lg text-[hsl(var(--ink))] sm:text-xl">
                    {f.q}
                  </span>
                  <span className="mt-1 grid h-7 w-7 shrink-0 place-items-center rounded-full border border-[hsl(var(--border))]">
                    {isOpen ? <Minus className="h-3.5 w-3.5" strokeWidth={1.8} /> : <Plus className="h-3.5 w-3.5" strokeWidth={1.8} />}
                  </span>
                </button>
                {isOpen && (
                  <div className="pb-6 pr-12 text-[hsl(var(--ink-soft))]">
                    <p className="whitespace-pre-line">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
